const routes = {
  //////////////////dashboardRoutes
  dashboardHome: { path: '/dashboard/home', isPrivate: true },
  dashboard: { path: '/dashboard', isPrivate: true },
  //A
  aboutUs: { path: '/aboutus', isPrivate: false },
  appdl: {
    path: '/mytipaxapp',
    isPrivate: false,
  },
  //B
  branches: { path: '/branches', isPrivate: false },
  branchCustomerProductType: { path: '/dashboard/branchCustomerProduct', isPrivate: true },

  //C
  contactUs: { path: '/contactup', isPrivate: false },

  productTerm: { path: '/productTerm', isPrivate: false },
  //customers
  customers: { path: '/dashboard/customers', isPrivate: true },
  //client
  client: { path: '/dashboard/client', isPrivate: true },
  clientUpdate: { path: '/dashboard/client/update', isPrivate: true },
  clientCreate: { path: '/dashboard/client/create', isPrivate: true },
  //customerPackaging
  customerPackagingConfirmation: { path: '/dashboard/omCustomerPackaging/confirmation', isPrivate: true },

  //customerPromotion
  customerPromotion: { path: '/dashboard/customer/promotion', isPrivate: true },

  //CustomerCodSettlementsList
  customerCodSettlementsList: { path: '/dashboard/customer/CodSettlementsLis', isPrivate: true },

  //F
  //financeInvoice
  invoices: { path: '/dashboard/invoices', isPrivate: true },
  customerFinancial: { path: '/dashboard/customerFinancial', isPrivate: true },
  financeInvoice: { path: '/dashboard/financeInvoice', isPrivate: true },
  financeWalletRefund: { path: '/dashboard/financeWalletRefund', isPrivate: true },
  // forgetPassword
  forgetPassword: { path: '/forgetPassword', isPrivate: false },
  forgetPasswordStepTwo: { path: '/forgetPassword/stepTwo', isPrivate: false },

  //L
  //loginWithGoogle
  loginWithGoogle: { path: '/loginWithGoogle', isPrivate: false },
  loginFormWithPhoneNumber: { path: '/loginFormWithPhoneNumber', isPrivate: false },

  //LTL
  ltlSteps: { path: '/dashboard/LTL/Steps', isPrivate: true },
  ltlDetail: { path: '/dashboard/LTL/Detail', isPrivate: true },
  ltlOrderList: { path: '/dashboard/LTLAllList', isPrivate: true },
  ltlOrderDetail: { path: '/dashboard/LTL/OrderDetail', isPrivate: true },
  ltlPrintBarcode: { path: '/dashboard/LTL/PrintBarcode', isPrivate: true },

  //O
  //orderPlace
  orderPlace: { path: '/dashboard/orderPlace', isPrivate: true },
  lockerOrderSubmit: { path: '/dashboard/lockerOrderSubmit', isPrivate: true },
  orderSubmit: { path: '/dashboard/orderSubmit', isPrivate: true },
  orderSubmitForBranch: { path: '/dashboard/orderSubmitForBranch', isPrivate: true },
  orderList: { path: '/dashboard/order/list', isPrivate: true },
  orderDetail: { path: '/dashboard/order/detail', isPrivate: true },
  preOrderDetail: { path: '/dashboard/preOrder/detail', isPrivate: true },
  bulkOrderingByExcel: { path: '/dashboard/bulkOrderingByExcel', isPrivate: true },
  orderWaitingSendToJet: { path: '/dashboard/orderWaitingSendToJet', isPrivate: true },
  advancedOrderRegistration: { path: '/dashboard/advancedOrderRegistration', isPrivate: true },
  createOrderResult: { path: '/dashboard/createOrderResult', isPrivate: true },
  returnedOrderList: { path: '/dashboard/returnedOrder/list', isPrivate: true },
  queueOrderList: { path: '/dashboard/queueOrderList', isPrivate: true },

  //R
  recieverAddress: { path: '/dashboard/recieverAddress', isPrivate: true },
  recieverAddressUpdate: { path: '/dashboard/recieverAddress/update', isPrivate: true },
  recieverAddressCreate: { path: '/dashboard/recieverAddress/create', isPrivate: true },
  recieverAddressTest: { path: '/recieverAddressTest', isPrivate: false },

  //P
  productType: { path: '/dashboard/productType', isPrivate: true },
  footerTermsAndCondition: { path: '/dashboard/termsAndCondition', isPrivate: false },
  //S
  //sender address
  senderAddress: { path: '/dashboard/senderAddress', isPrivate: true },
  senderAddressUpdate: { path: '/dashboard/senderAddress/update', isPrivate: true },
  senderAddressCreate: { path: '/dashboard/senderAddress/create', isPrivate: true },

  //setting
  setting: { path: '/dashboard/setting', isPrivate: true },
  //T
  ticket: { path: '/dashboard/ticket', isPrivate: true },
  ticketDetail: { path: '/dashboard/ticket/detail', isPrivate: true },
  ticketCreate: { path: '/dashboard/ticket/create', isPrivate: true },
  //termsAndConditions
  termsAndConditions: { path: '/dashboard/termsAndConditions', isPrivate: true },

  //P
  //Person
  personBankAccount: { path: '/dashboard/personBankAccount', isPrivate: true },
  personBusinessProfile: { path: '/dashboard/personBusinessProfile', isPrivate: true },
  //packaging
  packaging: { path: '/dashboard/packaging', isPrivate: true },
  packagingDetail: { path: '/dashboard/packaging/detail', isPrivate: true },
  packagingCreate: { path: '/dashboard/packaging/create', isPrivate: true },
  packagingUpdate: { path: '/dashboard/packaging/update', isPrivate: true },
  //parcel
  parcelOrderCompleteDetail: { path: '/dashboard/parcel/completeDetail', isPrivate: true },
  parcelDetail: { path: '/dashboard/omParcel/detail', isPrivate: true },
  parcelDetailPrint: { path: '/print/parcelDetailPrint', isPrivate: true },
  orderDetailPrint: { path: '/print/orderDetailPrint', isPrivate: true },
  unpaidOrder: { path: '/dashboard/unpaidorder', isPrivate: true },
  parcelBarcodePrint: { path: '/print/parcelBarcodePrint', isPrivate: false },
  parcelBarcodesPrintList: { path: '/print/parcelBarcodesPrintList', isPrivate: false },
  parcelList: { path: '/dashboard/parcel/list', isPrivate: false },
  //profile
  profile: { path: '/dashboard/profile', isPrivate: true },

  //S
  //substation
  substation: { path: '/dashboard/substation', isPrivate: true },

  //U
  userProfile: { path: '/dashboard/userProfile', isPrivate: true },

  //v
  verify: { path: '/payment', isPrivate: true },

  ///////////////HomeRoutes
  registerVerification: { path: '/registerverification', isPrivate: false },
  register: { path: '/register', isPrivate: false },
  login: { path: '/login', isPrivate: false },
  loginWithOtpCode: { path: '/loginWithOtpCode', isPrivate: false },
  home: { path: '/', isPrivate: false },
};

export default routes;
